/*
 * @Descripttion: 
 * @version: 
 * @Author: Blau
 * @Date: 2023-10-23 10:30:00
 * @LastEditors: Andy
 * @LastEditTime: 2023-10-23 11:00:12
 */
import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
     const permissions = store.getters && store.getters.resources
    // console.log(store.getters,store.getters.resources);
    let data = permissions.resources
    // console.log(data);
    let permin = []
    data.forEach(element => {
      permin.push(element.url)
    });

    if (value) {
      const permissionFlag = value

      const hasPermissions = permin.some(permission => {
        return permissionFlag.includes(permission)
      })

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      console.log('cuowu');
      // throw new Error(`请设置角色权限标签值"`)
    }
  }
}


// WEBPACK FOOTER //
// ./src/directive/hasPermi.js